import { type InfiniteData, useInfiniteQuery } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import type { IPaginationQueryParams } from "@/features/common/types";
import { queryKeyMap } from "@/features/query-client";

import { getListAuditLogs } from "../../api";

type ResponseType = Awaited<ReturnType<typeof getListAuditLogs>>;

interface IQueryOptions {
  enabled?: boolean;
}

export const useGetListAuditLogsQuery = (
  lenderCompanyId: number,
  options?: IQueryOptions,
) => {
  const DefaultLimit = 100;
  const DefaultOffset = 0;

  return useInfiniteQuery<
    ResponseType,
    AxiosError,
    InfiniteData<ResponseType>,
    ReturnType<typeof queryKeyMap.getListAuditLogs>,
    IPaginationQueryParams
  >({
    queryKey: queryKeyMap.getListAuditLogs(lenderCompanyId),
    queryFn: ({ pageParam }) => getListAuditLogs(lenderCompanyId, pageParam),
    getNextPageParam: (lastPage, _allPages, pageParam) => {
      if (lastPage.count < (pageParam.offset ?? DefaultLimit)) {
        return undefined;
      }

      return {
        offset: (pageParam.offset ?? 0) + DefaultLimit,
      };
    },
    initialPageParam: {
      limit: DefaultLimit,
      offset: DefaultOffset,
    },
    ...options,
  });
};
